/*
 * Cart reservation countdown (cosmetic). Counts down from the configured
 * minutes on each page load, MM:SS display.
 */
class CartCountdown extends HTMLElement {
  connectedCallback() {
    this.timer = this.querySelector('[data-cart-countdown-timer]');
    this.totalSeconds = Math.max(1, parseInt(this.dataset.minutes, 10) || 40) * 60;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    if (!this.timer) return;
    if (this.totalSeconds <= 0) {
      clearInterval(this.interval);
      return;
    }
    const minutes = Math.floor(this.totalSeconds / 60);
    const seconds = this.totalSeconds % 60;
    this.timer.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
    this.totalSeconds -= 1;
  }
}

customElements.define('cart-countdown', CartCountdown);
